import { Popover } from "@reactour/popover"
import React from "react"
import { popoverStyles } from "../ActivityContent/styles/GetStarted.styles"

export default function GetStarted({
  children,
  sizes,
  position = "top",
  extraStyles,
}) {
  return (
    <Popover
      sizes={sizes}
      position={position}
      styles={{
        popover: (base, state) => ({
          ...popoverStyles.popover(base, state),
          ...extraStyles?.popover?.(base, state),
        }),
      }}
    >
      {children}
    </Popover>
  )
}
